import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BackButtons: React.FC = () => {
  return (
    <div className="flex gap-4 mb-4">
      <Link 
        to="/admin/packages"
        className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Packages
      </Link>
    </div>
  );
};

export default BackButtons;